// Lib
import React from 'react';

/**
 * Prevents scale/zoom events from occurring in iPads when a pinch/scale
 * event gesture is attempted.
 */
const GlobalPinchGestureBlocker = () => {
    React.useEffect(() => {
        const onGestureStart = (event) => {
            if (!event.scale || event.scale === 1) return;

            event.preventDefault();
            event.stopPropagation();
        };

        document.addEventListener('gesturestart', onGestureStart);

        return () => {
            document.removeEventListener('gesturestart', onGestureStart);
        };
    }, []);

    return null;
};

GlobalPinchGestureBlocker.propTypes = {};

export default GlobalPinchGestureBlocker;
